var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-page',{attrs:{"icon":"mdi-database-cog","title":"Clients","actions":[
  {icon: 'mdi-plus', variant: 'success', title: 'Add client', route: {name : 'ClientAdd'}}
]}},[_c('paginated-result-loader',{attrs:{"enable-exports":false,"namespace":"clientsEdit"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('client-list',{attrs:{"items":props.items}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }